import VuexPersistence from "vuex-persist";

const vuexPersist = new VuexPersistence({
  storage: window.localStorage,
  modules: ["auth"],
});

export default vuexPersist;
